
import React from 'react';
import { motion } from 'framer-motion';

interface GradientBackgroundProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'accent';
  animated?: boolean;
}

export const GradientBackground: React.FC<GradientBackgroundProps> = ({
  children,
  variant = 'primary',
  animated = true,
}) => {
  const gradients = {
    primary: 'from-slate-950 via-purple-950/50 to-slate-950',
    secondary: 'from-slate-900 via-cyan-950/30 to-slate-900',
    accent: 'from-purple-950/30 via-pink-950/20 to-cyan-950/30',
  };

  return (
    <div className={`min-h-screen bg-gradient-to-br ${gradients[variant]} relative overflow-hidden`}>
      {animated && (
        <>
          <motion.div
            className="absolute inset-0 opacity-30"
            animate={{
              background: [
                'radial-gradient(circle at 20% 80%, rgba(120, 119, 198, 0.3) 0%, transparent 50%)',
                'radial-gradient(circle at 80% 20%, rgba(255, 119, 198, 0.3) 0%, transparent 50%)',
                'radial-gradient(circle at 40% 40%, rgba(120, 219, 255, 0.3) 0%, transparent 50%)',
              ],
            }}
            transition={{
              duration: 10,
              repeat: Infinity,
              repeatType: 'reverse',
            }}
          />
          <motion.div
            className="absolute inset-0 opacity-20"
            animate={{
              background: [
                'linear-gradient(45deg, transparent, rgba(120, 119, 198, 0.2), transparent)',
                'linear-gradient(135deg, transparent, rgba(255, 119, 198, 0.2), transparent)',
                'linear-gradient(225deg, transparent, rgba(120, 219, 255, 0.2), transparent)',
              ],
            }}
            transition={{
              duration: 8,
              repeat: Infinity,
              repeatType: 'reverse',
            }}
          />
        </>
      )}
      <div className="relative z-10">
        {children}
      </div>
    </div>
  );
};
